class HomeController {

    constructor(
        CurrentUser
    ){
        'ngInject';

        this.CurrentUser = CurrentUser;
    }

    $onInit() {
        this.showUserHome = this.CurrentUser.isUser();
        this.showHoldingHome = this.CurrentUser.isHolding() || this.CurrentUser.isDeactivated();
        this.showLoginHome = !this.CurrentUser.isLoggedIn();
    }

}

export default HomeController;


// WEBPACK FOOTER //
// ./app/components/home/home-controller.js